import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaPersonaContacto from "../vistas/vista_contacto";
import FormPersonaContacto from "../formularios/form_contacto";

export default class DesplegableContacto extends Component {
  render() {
    return (
      <Desplegable
        eventKey="11"
        id="11"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalMatrix[11]}
        Toogle={"Persona de Contacto"}
        Text={<VistaPersonaContacto DatosMonja={this.props.state.DatosUsuario}></VistaPersonaContacto>}
        Form={
          <FormPersonaContacto
            DatosMonja={this.props.state.DatosUsuario}
            setDatosHermana={this.props.setDatosHermana}
            handleButtonShow={this.props.handleButtonShow}
            ErrorHandling={this.props.ErrorHandling}
            setAlert={this.props.setAlert}
          ></FormPersonaContacto>
        }
        canEdit={true}
      />
    );
  }
}
